import "./error.scss";
import { $ } from "venuescanner-js/tools/elemental";
const showClass = "error-display";
const ErrorDisplay = {
  element: null,
  content: null,
  container: function () {
    if (!this.element) {
      this.element = $("<div></div>").addClass("error-dropdown");
      const dismiss = $(
        '<button type="button" class="button-close"></button>'
      ).click(() => {
        this.element.removeClass(showClass);
      });
      this.content = $("<div></div>");
      $(document.body).append(
        this.element.append(
          $("<div></div>").append(dismiss).append(this.content)
        )
      );
    }
    return { container: this.element, content: this.content };
  },
  closeTimeout: null,
  display: function (message, time = 3000) {
    const { container, content } = this.container();
    content.empty().append(message);
    setTimeout(() => {
      container.addClass(showClass);
    }, 0);
    // console.log(container.get(0))
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, time);
  },
  close: function () {
    const { container } = this.container();
    container.removeClass(showClass);
  },
  error: function (message, time = 5000) {
    this.display(
      $("<div></div>").addClass("error-message").html(message),
      time
    );
  },
  info: function (message, time = 10000) {
    this.display($("<div></div>").addClass("info-message").html(message), time);
  },
  warn: function (message, time = 5000) {
    this.display($("<div></div>").addClass("warn-message").html(message), time);
  },
};
export { ErrorDisplay };
